import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import user from "./slices/userSlice";
import staff from "./slices/staffSlice";
import candidate from "./slices/candidateSlice";
import vacancy from "./slices/vacancySlice";
import agency from "./slices/agencySlice";
import interview from "./slices/interviewSlice";
import application from "./slices/applicationSlice";
import offer from "./slices/offerSlice";
import dashboard from "./slices/dashboardSlice";
import configurations from "./slices/configurationsSlice";
import vacancyTitle from "./slices/vacancyNameSlice";
import report from "./slices/reportSlice";
const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    user,
    staff,
    candidate,
    vacancy,
    interview,
    agency,
    auth,
    report,
    application,
    offer,
    vacancyTitle,
    dashboard,
    configurations,
    ...asyncReducers,
  });
  if (action.type === "LOGOUT") {
    return combineReducers(undefined, action);
  } else {
    return combinedReducer(state, action);
  }
};

export default rootReducer;
